import { render, staticRenderFns } from "./ResultadosEncarte.vue?vue&type=template&id=88d299b6&scoped=true"
import script from "./ResultadosEncarte.vue?vue&type=script&lang=js"
export * from "./ResultadosEncarte.vue?vue&type=script&lang=js"
import style0 from "./ResultadosEncarte.vue?vue&type=style&index=0&id=88d299b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d299b6",
  null
  
)

export default component.exports